import 'slick-carousel';
import { $window } from '../utils/globals.js';

const addSlides = ($slider) => {
	if ($slider.find('.slider__slide').length % 5 === 0) {
		return
	} else {
		const slide = '<div class="slider__slide slider__slide--empty"></div>';
		$slider.append(slide);
		addSlides($slider);
		return;
	}
};

const handleSliderProducts = () => {
	const $slider = $('.js-slider-products');

	$slider.each(function(index, el) {
		const $this = $(this);
		const $slides = $this.find('.slider__slides');

		addSlides($slides);

		$slides.slick({
		  infinite: true,
		  slidesToShow: 5,
		  slidesToScroll: 5,
		  dots: false,
		  arrows: true,
		  autoplay: false,
		  adaptiveHeight: true,
		  prevArrow: $this.find('.js-slider-arrow-prev'),
		  nextArrow: $this.find('.js-slider-arrow-next'),
		  responsive: [
		    {
		      breakpoint: 1023,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1
		      }
		    }
		  ]
		});

		function getLastSlide(){
			return ($slides.slick('getSlick').slideCount - 1);
		}

		function dynamicSlides() {
			$slides.slick('slickAdd', '<div></div>', getLastSlide());
			return
		};

	    $window.on('load resize', function() {
	    	clearTimeout(debounce)

	    	const debounce = setTimeout(() => {
			    const $emptySlides = $slides.find('.slick-slide:not(.slick-cloned) > div > .slider__slide--empty');

				if ($window.width() < 1024) {
					for (let i = 0; i < $emptySlides.length; i++) {
				    	$slides.slick('slickRemove', getLastSlide());
				    }
				} else {
					if ($slides.find('.slick-slide:not(.slick-cloned)').length % 5 === 0) {
						return
					} else {
						dynamicSlides();
						return
					}
				}
	    	}, 200)
	    });
	});
};

handleSliderProducts();

